import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"





export default function Navbar(props) {
  let txt = "Enable Dark mode";
  
  const change = () =>{
    let changes = '';
    if(props.mode === 'light'){
      changes = 'dark-blue';
      txt = "Enable Dark mode";
      

    }else{
      changes = 'light';
      txt = "Disable Dark mode"
     
    }
     
    return changes
  }

  return (
    <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
  <a className="navbar-brand" href="/">{props.title}</a>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <div className="collapse navbar-collapse" id="navbarSupportedContent">
    <ul className="navbar-nav mr-auto">
      <li className="nav-item active">
        <Link className="nav-link" to="/">Home <span className="sr-only">(current)</span></Link>
      </li>
      <li className="nav-item active">
        <Link className="nav-link" to="/about">About <span className="sr-only">(current)</span></Link>
      </li>
   
     
     
    </ul>
    <div>


<div className='bg-primary rounded mx-2' style={{height:'30px',width:'30px',cursor:'pointer'}} onClick={()=>{props.toggleMode('primary')}} ></div>




    </div>
    <div><div className='bg-danger rounded mx-2' style={{height:'30px',width:'30px',cursor:'pointer'}} onClick={()=>{props.toggleMode('danger')}} ></div></div>
    <div><div className='bg-success rounded mx-2' style={{height:'30px',width:'30px',cursor:'pointer'}} onClick={()=>{props.toggleMode('success')}} ></div></div>
    <div><div className='bg-warning rounded mx-2' style={{height:'30px',width:'30px',cursor:'pointer'}} onClick={()=>{props.toggleMode('warning')}} ></div></div>
    {/* <form className="form-inline my-2 my-lg-0">
      <input className="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search"/>
      <button className="btn btn-outline-primary my-2 my-sm-0" type="submit">Search</button>
    </form> */}
    <div className={`form-check form-switch text-${change()}`}> 
    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault"  onClick={()=>{props.toggleMode(props.mode==='dark'?'light':'dark')}}  />
    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">toggle mode</label>
    </div>
  </div>
</nav>
  )
}
Navbar.propTypes = {title : PropTypes.string}
Navbar.defaultProps = {title: 'set title here'};